/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {ThunderDispatcher} from "@intuitionrobotics/thunderstorm/frontend";
import {Module} from "@intuitionrobotics/ts-common";
import dayjs from "../app/utils/dayjs";


export enum TimeFilterOptions {
    CHOOSE_DAYS,
    DAYS_7,
    DAYS_14,
    DAYS_30,
    MONTHS_6,
    YEAR_1,
}

export type TimeFilterOption = {
    option: TimeFilterOptions
    value: string
    days: number
}

export interface OnTimeFilterChanged {
    __onTimeFilterChanged: () => void;
}

export const dispatch_onTimeFilterChanged = new ThunderDispatcher<OnTimeFilterChanged, "__onTimeFilterChanged">("__onTimeFilterChanged");

export const PARAM_PATIENT = "customerId";
export const PARAM_ALERT = "alertId";

export class UserPreferencesModule_Class
    extends Module {

    private lastMainRoute?: string;

    setLastMainRoute = (route: string) => {
        this.lastMainRoute = route;
    };

    getLastMainRoute = () => this.lastMainRoute;

    static TimeFilterOptions: TimeFilterOption[] = [
        {
            option: TimeFilterOptions.CHOOSE_DAYS,
            value: "Download Health Tracking Data for the period:",
            days: 0
        },
        {
            option: TimeFilterOptions.DAYS_7,
            value: "7 days",
            days: 7
        },
        {
            option: TimeFilterOptions.DAYS_14,
            value: "14 days",
            days: 14
        },
        {
            option: TimeFilterOptions.DAYS_30,
            value: "30 days",
            days: 30
        },
        {
            option: TimeFilterOptions.MONTHS_6,
            value: "6 months",
            days: 183
        },
        {
            option: TimeFilterOptions.YEAR_1,
            value: "1 year",
            days: 365
        }
    ];

    private timeFilterSelectedOption = {
        option: TimeFilterOptions.MONTHS_6,
        value: "6 months",
        days: 183
    };

    constructor() {
        super("UserPreferencesModule");
    }

    getTimeFilterOptions() {
        return UserPreferencesModule_Class.TimeFilterOptions;
    }

    getTimeFilterSelectedOption() {
        return this.timeFilterSelectedOption;
    }

    public setTimeFilterSelectedOption(o: TimeFilterOption) {
        this.timeFilterSelectedOption = o;
        dispatch_onTimeFilterChanged.dispatchUI();
        dispatch_onTimeFilterChanged.dispatchModule();
    }

    getStartingDate() {
        if (this.timeFilterSelectedOption === undefined)
            return dayjs(0).toDate();

        let d = dayjs();
        d = d.set("date", d.date() - this.timeFilterSelectedOption.days).startOf("day");
        return d.toDate();
    }

}


export const UserPreferencesModule = new UserPreferencesModule_Class();
